import React from "react";
import { lazyWithRetry } from "utils/lazy-with-retry";

const LazyTeamSettings = lazyWithRetry(() => import("./TeamSettings"));

const TeamSettings = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyTeamSettings {...props} />;

export default TeamSettings;
